const Style = {
    row: 'flex justify-center gap-2 sm:gap-3',
    cell: `h-12 w-10 rounded-md border border-border bg-surface text-center text-lg font-semibold
        text-text-primary shadow-sm outline-none transition
        focus:border-primary-500 focus:ring-2 focus:ring-primary-500/30
        sm:h-14 sm:w-12`,
    cellError: 'border-error focus:border-error focus:ring-error/30',
    error: 'text-center text-sm text-error',
    hint: 'text-center text-sm text-text-muted',
};

export default Style;
